import { httpClient } from "@coworker/http-client";
import { useQuery } from "@tanstack/react-query";

export interface ItemStockInfo {
  available: number;
  elevated: number | null;
}

async function fetchItemStockInfo(itemType: string, itemNo: string) {
  return await httpClient.tasks.get<ItemStockInfo>(
    `/items/item-stock?itemNo=${itemNo}&itemType=${itemType}`
  );
}

export function useItemStock(
  itemType: string,
  itemNo: string,
  { enabled = true }: { enabled?: boolean } = {}
) {
  return useQuery({
    queryKey: ["item", "stock", itemType, itemNo],
    queryFn: async () => await fetchItemStockInfo(itemType, itemNo),
    staleTime: 86400000, // 1 day, considered fresh for a day.
    refetchOnWindowFocus: false,
    enabled: enabled && !!itemNo && !!itemType,
  });
}
